import React from 'react';
import PropTypes from 'prop-types';

import ProductUnitDetails from './ProductUnitDetails';

const ProductUnitSummary = ({
  unitTitle,
  detailStr = '',
  pricePerItem,
  itemListPrice,
  checkoutItems,
  minQuantityPerPackage = [],
  crossPost = false,
  multiMediaAddOn = false,
}) => {
  // MultiMediaAddOns cost $79 regardless of how many added,
  // so treat them as a single item for computations
  const numItems = (multiMediaAddOn ? 1 : checkoutItems.length);
  const totalItemsPrice = numItems * pricePerItem;
  const totalItemsListPrice = numItems * itemListPrice;
  const bulkOrderDiscountMessage = (additionalPublications) => {
    const totalPublications = additionalPublications + 1; // to include original publication
    let packageType = null;
    for (let i = 0; i < minQuantityPerPackage.sort((a, b) => a - b).length; i += 1) {
      if (totalPublications >= minQuantityPerPackage[i]) packageType = minQuantityPerPackage[i];
    }
    return (crossPost
            && packageType
            && (<ProductUnitDetails detailStr={`${packageType}+ Postings bulk order discount applied`} />));
  };

  return (
    <div className="pr-checkout-item">
      <div className="pr-checkout-item__title" style={{ fontSize: '1.25rem', fontWeight: '500', lineHeight: '1.5' }}>
        {(numItems > 1) ? (
          <span>{unitTitle} ${(pricePerItem / 100).toLocaleString()} each</span>
        ) : (
          <span>{unitTitle}</span>
        )}
        <span>
          {(totalItemsPrice !== totalItemsListPrice
            && (
              <span className="pr-checkout-item__old-price">${(totalItemsListPrice / 100).toLocaleString()}</span>
            )
          )}
          ${(totalItemsPrice / 100).toLocaleString()}
        </span>
      </div>

      {detailStr && (
        <ProductUnitDetails detailStr={detailStr} />
      )}

      {crossPost && checkoutItems.map((crossPostSite) => (
        <ProductUnitDetails key={crossPostSite.site_id} detailStr={crossPostSite.site_name} />
      ))}

      {bulkOrderDiscountMessage(checkoutItems.length)}
    </div>
  );
};

ProductUnitSummary.propTypes = {
  unitTitle: PropTypes.string.isRequired,
  detailStr: PropTypes.string,
  pricePerItem: PropTypes.number.isRequired,
  itemListPrice: PropTypes.number.isRequired,
  checkoutItems: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]),
  ).isRequired,
  minQuantityPerPackage: PropTypes.arrayOf(PropTypes.number),
  crossPost: PropTypes.bool,
  multiMediaAddOn: PropTypes.bool,
};

export default ProductUnitSummary;
